import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { NgForm } from "@angular/forms";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";

import { Loan } from "../shared/loan";
import { LoanService } from "../shared/loan.service";

@Component({
  selector: 'app-loanapproval',
  templateUrl: './loanapproval.component.html',
  styleUrls: ['./loanapproval.component.css']
})

export class LoanapprovalComponent implements OnInit {

  displayedColumns: string[] = ['Application No', 'Application Date', 'Customer', 'Scheme', 'Amount', 'Approved As', 'Centre', 'Mobile', 'New'];

  LoanList$ : any[] =[];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  selected = new FormControl(0);
  LoanApprovedStatus: number = 1;    // because we need pending list for branch Approved loan
  public selectedLoan: Loan;
  PaymentModeList: any[] = [];
  BankLedgerVisibility:boolean = false;
  BankLedgerList: any[] = [];
  //   -- 0 for pending status
  //   -- 1 for branch Approved Status
  //   -- 2 for loan Approved Status
  //   -- 3 for branch reject status
  //   -- 4 for loan reject status   
  //   -- 5 for branch revert status  // using for any document clearance.
  //   -- 6 for loan revert status    // using for any document clearance.
  
  constructor(private router: Router, public loanService: LoanService,
    private commonmastersService: CommonmastersService) { 
      
    }

  ngOnInit() {
    this.getLoanList();
    this.GetPaymentMode();
    this.GetBankLedgerList();
    this.dataSource.paginator = this.paginator;
    this.loanService.selectedLoan.PaymentTypeId = 2; //--"Default Bank" 
    this.loanService.selectedLoan.PaymentBankId = 0;
  }

  getLoanList() {
    this.selectedLoan = new Loan();
    this.selectedLoan.SearchByApprovedStatus = 1;
    this.selectedLoan.LoanApprovedStatusId = this.LoanApprovedStatus;

    this.loanService.FetchLoanList(this.selectedLoan)
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }

  public ApprovalTabIndex = 0;

  public ApprovalAction(loan: any) {
    const tabCount = 2;
    this.ApprovalTabIndex = (this.ApprovalTabIndex + 1) % tabCount;

    this.loanService.selectedLoan.Id =  loan.Id;
    this.loanService.selectedLoan.IsCustomerSearch =  true;
    this.loanService.selectedLoan.LoanApprovedStatusId = this.LoanApprovedStatus;

    this.loanService.LoanApprovalByLoanNo(this.loanService.selectedLoan).toPromise().then(data => {

      this.loanService.selectedLoan.Id = data.Id;
      this.loanService.selectedLoan.CustomerId = data.CustomerId;
      this.loanService.selectedLoan.ApplicationNo = data.ApplicationNo;
      this.loanService.selectedLoan.ApplicationDate = data.ApplicationDate;
      this.loanService.selectedLoan.Recommendation = data.Recommendation;
      this.loanService.selectedLoan.ApprovedRemarks = data.ApprovedRemarks;
      this.loanService.selectedLoan.LoanTypeId = data.LoanTypeId;
      this.loanService.selectedLoan.LoanAmount = data.LoanAmount;
      this.loanService.selectedLoan.Schemename = data.SchemeName;
      this.loanService.selectedLoan.InterestType = data.InterestType;
      this.loanService.selectedLoan.CustomerName = data.CustomerName;
      this.loanService.selectedLoan.CustomerAddress = data.CustomerAddress;
    })
      .catch(err => { console.log(err) });
  }

  ViewLoan(loan: any) {
    this.router.navigate(['/loan', loan.Id]);
  }

  ClickApprove(event) {
    this.loanService.selectedLoan.LoanApprovedStatusId = 2; // 2 for loan Approved Status
    this.loanService.selectedLoan.IsApprovalClick = true;
    this.IUDRevert_Reject_Approve();
  }

  ClickReject(event) { 
    this.loanService.selectedLoan.LoanApprovedStatusId = 4; // 4 for loan reject status
    this.loanService.selectedLoan.IsApprovalClick = true;
    this.IUDRevert_Reject_Approve();
  }

  ClickRevert(event) {
    this.loanService.selectedLoan.LoanApprovedStatusId = 6; // 6 for loan revert status
    this.loanService.selectedLoan.IsApprovalClick = true;
    this.IUDRevert_Reject_Approve();
  }

  IUDRevert_Reject_Approve() {
    this.loanService.selectedLoan.LoanApprovedBy = JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.loanService.selectedLoan.LoanApprovedDate =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    
    if (this.loanService.selectedLoan.CustomerName != null) {
      this.loanService.IUDLoan(this.loanService.selectedLoan)
        .toPromise()
        .then(data => {
          this.getLoanList();
          this.ApprovalTabIndex = 0;
        })
    }
    // this.ApprovalTabIndex = 0;
  }

  GetBankLedgerList(){ 
    this.loanService.FetchBankLedgerList()
    .toPromise()
    .then(data => {
      this.BankLedgerList = data;
    })
  }

  GetPaymentMode() {
    this.commonmastersService.FetchPaymentMode().subscribe(data => {
      this.PaymentModeList = data;
    })
  }

  ShowBankList(Id : number){
    if(Id == 2)//Bank
    {
     this.BankLedgerVisibility = true;
    }
    else{
     this.BankLedgerVisibility = false;
    }
   }

}


